<template>
  <div>
    <Header v-if="$route.query.out || out" :pageTitle="pageTitle">
      <template #right>
        <img
          class="search-icon"
          src="@/assets/img/mobile-img/search.png"
          @click="toSearch"
        />
        <van-icon name="ellipsis" @click="rightBut" />
      </template>
    </Header>
    <OpenAPP v-else />
  </div>
</template>

<script>
import { Icon } from "vant";
import Header from "@/views/mobileView/components/header";
import OpenAPP from "./openAPP";
export default {
  components: {
    Header,
    OpenAPP,
    "van-icon": Icon,
  },
  props: {
    pageTitle: {
      // nav显示页面标题
      type: String,
      default: "",
    },
    out: {
      type: Boolean,
      default: false,
    },
    shareInfo: {
      // 分享APP类型分类 articleType(文章分类): 0论文 2专著 5资讯 8会议 9课程 11图书  userType(用户分类): 0学者 1期刊 2机构 3名录
      type: Object,
    },
  },
  mounted() {
    // 将词典搜索方法挂载window上供APP使用
    window["goDictionaries"] = (query) => {
      this.getDictionary(query);
    };
  },
  methods: {
    toSearch() {
      if (this.$global.isAndroid_ios()) {
        window.android.openSearch();
      } else {
        window.webkit.messageHandlers.openSearch.postMessage("");
      }
    },
    // 字典方法
    getDictionary(query) {
      let searchStr = "";
      if (this.$global.isAndroid_ios()) {
        searchStr = query.body.value;
      } else {
        if (typeof query == "string") {
          searchStr = JSON.parse(query).body.value;
        }
      }
      this.$router.push({
        name: "dictionaryDetail",
        params: {
          searchStr,
          out: "android",
        },
      });
    },
    // 右侧按钮((sharing为协商的方法名))
    rightBut() {
      let Url = this.eliminate();
      let sharInfo = {
        ...this.shareInfo,
        isCollect: sessionStorage.getItem("isCollect")
          ? sessionStorage.getItem("isCollect")
          : "",
        pageUrl: Url + "share=false",
        shareBox: "top",
      };
      console.log(sharInfo);
      const shareJson = JSON.stringify(sharInfo);
      if (this.$global.isAndroid_ios()) {
        window.android.sharing(shareJson);
      } else {
        window.webkit.messageHandlers.sharing.postMessage(shareJson); //ios
      }
    },
    eliminate() {
      // 分享 复制链接剔除特殊字段
      let url = document.location.toString();
      let urlArr = url.split("?");
      let baseUrl = urlArr[0] + "?";
      let params = Object.create(null);
      if (urlArr.length > 1) {
        urlArr = urlArr[1].split("&");
        urlArr.forEach((item) => {
          item = item.split("=");
          if (
            item[0] === "out" ||
            item[0] === "app" ||
            item[0] === "share" ||
            item[0] === "token"
          ) {
            return;
          }
          {
            params[item[0]] = item[1];
          }
        });
      }
      for (const key in params) {
        baseUrl = baseUrl + [key] + "=" + params[key] + "&";
      }
      return baseUrl;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .search-icon {
  margin-right: 20px;
  width: 20px;
  height: 20px;
}
</style>
